import { useState } from "react";
import type { ReactElement } from "react";
import { Button } from "../ui-kit";
import { getActiveTheme, setTheme } from "../lib/theme";
import type { Theme } from "../lib/theme";
import styles from "./ThemeToggle.module.css";

const NEXT_THEME: Record<Theme, Theme> = { light: "dark", dark: "light" };

/**
 * Switches between the light and dark token mappings. The label names the
 * ACTION ("Switch to dark theme"), not the state, so a screen-reader user
 * knows what pressing it will do; the icon is decorative reinforcement.
 */
export function ThemeToggle(): ReactElement {
  const [theme, setThemeState] = useState<Theme>(() => getActiveTheme());
  const next = NEXT_THEME[theme];

  function toggle(): void {
    setTheme(next);
    setThemeState(next);
  }

  return (
    <Button variant="ghost" size="sm" onClick={toggle} aria-label={`Switch to ${next} theme`}>
      <span className={styles.icon} aria-hidden="true">
        {theme === "dark" ? "☀" : "☾"}
      </span>
      <span className={styles.label}>{next === "dark" ? "Dark" : "Light"}</span>
    </Button>
  );
}
